export default "__VITE_ASSET__5e344832__"